export * from './communicationRoutes';